import { useEffect } from "react";
import useStore from "../useStore";
import { TRANSLATIONS } from "../Constants/i18n";

export const useTranslation = () => {
  const language = useStore((state) => state.language);
  const setLanguage = useStore((state) => state.setLanguage);

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  return { t: TRANSLATIONS[language], language, setLanguage };
};
